import { gql, useQuery } from "@apollo/client";
import Errors from "components/base/Errors";
import { InlineSpinner } from "components/base/Spinner";
import { Select } from "components/base/Form";

const FETCH_PRODUCTION_CATEGORIES = gql`
  query FETCH_PRODUCTION_CATEGORIES {
    allProductionCategories {
      id
      name
      factory {
        id
        name
      }
    }
  }
`;

const ProductionCategorySelector = ({ value, onChange }) => {
  const { loading, error, data } = useQuery(FETCH_PRODUCTION_CATEGORIES);

  if (loading) return <InlineSpinner size={16} />;
  if (error) return <Errors error={error} />;

  return (
    <Select
      className="w-60 text-xs"
      value={value ? value.id : "0"}
      onChange={(e) =>
        onChange(
          data.allProductionCategories.find((i) => i.id === e.target.value),
        )
      }
    >
      <option value="0" disabled>
        -- Select Producion Category --
      </option>
      {data.allProductionCategories.map((i) => (
        <option key={i.id} value={i.id}>
          {i.factory.name} : {i.name}
        </option>
      ))}
    </Select>
  );
};
export default ProductionCategorySelector;
